import { Box, Link, Typography } from '@mui/material';
import { Login, LoginForm } from 'react-admin';
import { Link as RouterLink } from 'react-router-dom';
import ForgeWordmark from './components/ForgeWordmark.tsx';
import { PUBLIC_BACKGROUND } from './components/PublicPage.tsx';
import { FORGE_URL } from './demo/demoLinks.ts';
import { SIGNUP_URL } from './signup/signupLinks.ts';

const NLC_URL = 'https://www.nlc.consulting';

/**
 * Branded wrapper around react-admin's <Login>. Keeping RA's component means the
 * authenticated-user redirect and the sign-in form behave exactly as before;
 * only the surface changes.
 */
const ForgeLogin = () => (
  <Login
    sx={{
      // NLC's background, not react-admin's default purple.
      backgroundImage: PUBLIC_BACKGROUND,
      '& .RaLogin-avatar': { display: 'none' },
      '& .RaLogin-card': { minWidth: 300, mt: '6em', mb: '7em', borderRadius: 3, position: 'relative', overflow: 'visible' }
    }}
  >
    <Box sx={{ px: 3, pt: 3, pb: 1, textAlign: 'center' }}>
      <ForgeWordmark centered />
    </Box>

    <LoginForm />

    <Box
      sx={{
        px: 3,
        py: 1.75,
        borderTop: 1,
        borderColor: 'divider',
        textAlign: 'center'
      }}
    >
      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
        New to Forge?{' '}
        <Link component={RouterLink} to="/demo" sx={{ fontWeight: 600 }}>
          Try the demo
        </Link>
        {' or '}
        <Link href={SIGNUP_URL} sx={{ fontWeight: 600 }}>
          sign up
        </Link>
      </Typography>
      <Link
        href={FORGE_URL}
        target="_blank"
        rel="noopener noreferrer"
        variant="body2"
        sx={{ display: 'inline-block', mt: 0.5, fontWeight: 600 }}
      >
        See what Forge does
      </Link>
    </Box>

    {/* Sits below the card, on the page background. <Login> renders no slot
        outside the card, so anchor it to the card's bottom edge instead. */}
    <Box sx={{ position: 'absolute', top: '100%', left: 0, right: 0, mt: 3.5, textAlign: 'center' }}>
      <Link
        href={NLC_URL}
        target="_blank"
        rel="noopener noreferrer"
        sx={{ display: 'inline-block', lineHeight: 0, opacity: 0.85, '&:hover': { opacity: 1 } }}
        aria-label="NLC Consulting"
      >
        <Box
          component="img"
          src="/nlc-logo.png"
          alt="NLC Consulting"
          sx={{ width: 116, height: 'auto', display: 'block' }}
        />
      </Link>
    </Box>
  </Login>
);

export default ForgeLogin;
